// api.js

import axiosInstance from "../axiosInstance";

export const usersService = {
  create: async (data) => {
    try {
      let response = await axiosInstance.post("/users", {
        ...data,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  createClientUser: async (data) => {
    try {
      let response = await axiosInstance.post("/client-team", {
        ...data,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (limit, skip, clientId, searchValue) => {
    try {
      let searchQuery = "";
      if (searchValue) {
        // Search on both name and email using $or operator
        searchQuery = `&$or[0][name][$search]=${searchValue}&$or[1][email][$search]=${searchValue}`;
      }

      let response = await axiosInstance.get(
        `/users?$populate=roles&$limit=${limit || 15}&$skip=${skip || 0}&${
          clientId ? `client_id=${clientId}` : ""
        }${searchQuery}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchView: async (limit, skip, clientId, query) => {
    try {
      let api = `/user-view?$populate=roles&$limit=${limit || 15}&$skip=${
        skip || 0
      }`;
      if (query) {
        api += `&${query}`;
      }
      if (clientId) {
        api += `&clients=${clientId}`;
      } else {
        api += `&$populate[0][path]=clients`;
      }

      let response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (usersData, id) => {
    try {
      let response = await axiosInstance.patch(`/users/${id}`, {
        ...usersData,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/users/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchUsersuniqueFields: async (
    key,
    searchKey,
    client,
    limit = 15,
    skip = 0
  ) => {
    try {
      let query = `limit=${limit}&skip=${skip}&key=${key}`;
      if (client) {
        query += `&client=${client}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }
      let response = await axiosInstance.get(
        `/fetch-user-unique-fields?${query}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
